export const FormCheck: React.FC<
  Omit<React.InputHTMLAttributes<HTMLInputElement>, 'className' | 'type'>
> = (props) => (
  <input
    {...props}
    type="checkbox"
    className="tw-relative tw-h-[1.5rem] tw-w-[1.5rem] tw-appearance-none tw-align-middle tw-outline-none before:tw-absolute before:tw-h-full before:tw-w-full before:tw-rounded-4 before:tw-border-[2px] before:tw-border-main-80 before:tw-content-[''] after:tw-absolute after:tw-inset-0 after:tw-m-auto  after:tw-block after:tw-h-[0.5rem] after:tw-w-[0.25rem] after:tw-rotate-45 after:tw-content-[''] checked:before:tw-bg-main-100 checked:after:tw-border-b-[2px] checked:after:tw-border-r-[2px] checked:after:tw-border-base-lv1"
  />
);
